import React, { useEffect, useState } from 'react';
import axios from 'axios';

const FooterContactInfoNew = () => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    const fetchContactInfo = async () => {
      try {
        const url = `${process.env.REACT_APP_API_URI}/contactInfo`;
        const response = await axios.get(url);
        const rawData = Array.isArray(response?.data) ? response.data : [];

        // Deduplicate records that have identical phone, email, and address
        const seen = new Set();
        const unique = [];
        for (const item of rawData) {
          const key = `${(item.phone || '').trim()}|${(item.email || '').trim()}|${(item.address || '').trim()}`;
          if (!seen.has(key)) {
            seen.add(key);
            unique.push(item);
          }
        }

        if (isMounted) {
          setContacts(unique.length > 0 ? unique : rawData.slice(0, 1));
        }
      } catch (err) {
        console.error('Footer contactInfo load error:', err);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchContactInfo();
    return () => {
      isMounted = false;
    };
  }, []);

  if (loading && contacts.length === 0) {
    return (
      <div className="widget footer-widget widget-contact clearfix">
        <h3 className="widget-title">Quick Contact</h3>
        <p className="footer-loading-text">Loading contact details...</p>
      </div>
    );
  }

  if (!contacts || contacts.length === 0) {
    return null;
  }

  const isMulti = contacts.length > 1;

  return (
    <div className="widget footer-widget widget-contact clearfix">
      <h3 className="widget-title">Quick Contact</h3>

      <div className="footer-contact-stack">
        {contacts.map((item, index) => (
          <div key={item.id || index} className="footer-contact-card">
            {isMulti && (
              <div className="contact-branch-badge">
                <i className="fa-solid fa-location-dot"></i>
                <span>Office {index + 1}</span>
              </div>
            )}

            <div className="contact-info-list">
              {item.phone && (
                <div className="contact-info-row">
                  <div className="contact-icon-circle">
                    <i className="flaticon flaticon-phone-call"></i>
                  </div>
                  <div className="contact-text-group">
                    <span className="contact-text-label">Phone</span>
                    <a href={`tel:${item.phone}`} className="contact-primary-val">
                      {item.phone}
                    </a>
                    {item.secondary_phone && item.secondary_phone !== item.phone && (
                      <a href={`tel:${item.secondary_phone}`} className="contact-secondary-val">
                        {item.secondary_phone}
                      </a>
                    )}
                  </div>
                </div>
              )}

              {item.email && (
                <div className="contact-info-row">
                  <div className="contact-icon-circle">
                    <i className="flaticon flaticon-email"></i>
                  </div>
                  <div className="contact-text-group">
                    <span className="contact-text-label">Email</span>
                    <a href={`mailto:${item.email}`} className="contact-primary-val">
                      {item.email}
                    </a>
                    {item.secondary_email && item.secondary_email !== item.email && (
                      <a href={`mailto:${item.secondary_email}`} className="contact-secondary-val">
                        {item.secondary_email}
                      </a>
                    )}
                  </div>
                </div>
              )}

              {item.address && (
                <div className="contact-info-row">
                  <div className="contact-icon-circle">
                    <i className="flaticon flaticon-placeholder"></i>
                  </div>
                  <div className="contact-text-group">
                    <span className="contact-text-label">Location</span>
                    <span className="contact-address-val">{item.address}</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FooterContactInfoNew;
